import { BaseRequests } from "../../../config/BaseRequests";
import { authApiEndpoints } from "../api/auth.api";
import { LoginRequestDto, LoginResponseDto } from "../dto/auth.dto";

export class AuthService {
  static login = (data: LoginRequestDto): Promise<LoginResponseDto> =>
    BaseRequests.post(authApiEndpoints.login, data);
}
